import { WrapText, AlignLeft } from "lucide-react";
import { languageLabelFor } from "../utils/languageInfo";

interface Props {
  path: string;
  line: number;
  col: number;
  selection: number;
  dirty: boolean;
  wrapLines: boolean;
  onToggleWrap: () => void;
  meter?: { in: number; out: number; cached: number; cents: number } | null;
}

export function EditorStatusBar({
  path,
  line,
  col,
  selection,
  dirty,
  wrapLines,
  onToggleWrap,
  meter,
}: Props) {
  return (
    <div className="editor-statusbar" role="status">
      <div className="editor-statusbar__left">
        <span
          className="editor-statusbar__dirty"
          data-on={dirty ? "true" : "false"}
          aria-hidden="true"
        >
          {dirty ? "●" : "○"}
        </span>
        <span className="editor-statusbar__pos">
          Ln {line}, Col {col}
          {selection > 0 ? ` (${selection} sel)` : ""}
        </span>
      </div>
      <div className="editor-statusbar__right">
        <button
          type="button"
          className="editor-statusbar__btn"
          onClick={onToggleWrap}
          title={wrapLines ? "Disable word wrap" : "Enable word wrap"}
          aria-pressed={wrapLines}
        >
          {wrapLines ? <WrapText size={12} /> : <AlignLeft size={12} />}
          <span>{wrapLines ? "Wrap" : "No wrap"}</span>
        </button>
        <span className="editor-statusbar__lang">{languageLabelFor(path)}</span>
        {meter && (
          <span
            className="editor-status-meter"
            title={`in ${meter.in} • out ${meter.out} • cached ${meter.cached}`}
          >
            {meter.cents.toFixed(2)}¢
          </span>
        )}
      </div>
    </div>
  );
}
